export class Species {
    id;
    speciesName = "";
    
    constructor({ id, speciesName }) {
        this.id = id;
        this.speciesName = speciesName;
    }
}